// ===== Popup Position Util =====
// 앵커 요소 위에 팝업을 띄우되, 뷰포트 밖으로 나가면 좌우 클램프 + 아래로 폴백한다.
// factory/harness step-popup 이 공유한다.

function positionPopupNearAnchor(popup: HTMLElement, anchor: HTMLElement): void {
  popup.style.display = "block";
  const rect = anchor.getBoundingClientRect();
  const popW = popup.offsetWidth;
  const popH = popup.offsetHeight;
  let left = rect.left + rect.width / 2 - popW / 2;
  let top = rect.top - popH - 8;
  if (left < 4) left = 4;
  if (left + popW > window.innerWidth - 4) left = window.innerWidth - popW - 4;
  if (top < 4) top = rect.bottom + 8;
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
}
